"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SlideModal = void 0;
const react_1 = __importStar(require("react"));
const makeStyles_1 = __importDefault(require("@mui/styles/makeStyles"));
const Paper_1 = __importDefault(require("@mui/material/Paper"));
const Slide_1 = __importDefault(require("@mui/material/Slide"));
const Fade_1 = __importDefault(require("@mui/material/Fade"));
const Typography_1 = __importDefault(require("@mui/material/Typography"));
const _1 = require(".");
const SlideModal = ({ open, variant, onClose, getContainerStyles, getPaperStyles, options = {}, Title, CloseButton, children }) => {
    const classes = useStyles();
    const styles = getContainerStyles === null || getContainerStyles === void 0 ? void 0 : getContainerStyles({});
    const paperStyles = getPaperStyles === null || getPaperStyles === void 0 ? void 0 : getPaperStyles({});
    const isHalfModal = react_1.useMemo(() => variant === _1.ModalVariant.HALF_SLIDE, [variant]);
    const modal = react_1.useRef(null);
    const modalParent = react_1.useRef(null);
    const [tabList, setTabList] = react_1.useState(null);
    const handleOnClickClose = e => {
        onClose(e, _1.ModalCloseMechanism.ICON_CLICK);
    };
    // This useEffect is required to run on every re-render of the component,
    // otherwise focus will not work properly.
    react_1.useEffect(() => {
        if (modal && modal.current)
            modal.current.focus();
    });
    react_1.useEffect(() => {
        if (modalParent.current) {
            // Gets all of the elements with tabindex set to keep track of all tabblable elements.
            // Sets it to state while casting to an Array instead of NodeList.
            setTabList(Array.prototype.slice.call(modalParent.current.querySelectorAll('[tabindex]')));
        }
    }, [modalParent]);
    react_1.useEffect(() => {
        const keyboardCallback = (event) => {
            if (event.key === 'Escape')
                onClose(event, _1.ModalCloseMechanism.ESCAPE_KEY_DOWN);
            if (event.key !== 'Tab' || !tabList || !tabList.length)
                return;
            // Using a for-loop here to be able to break out of the loop.
            for (const [index, node] of tabList.entries()) {
                if (node.isSameNode(event.target)) {
                    if (!tabList[index + 1] && modal.current) {
                        event.preventDefault();
                        modal.current.focus();
                        break;
                    }
                }
            }
        };
        document.addEventListener('keydown', keyboardCallback);
        return () => {
            document.removeEventListener('keydown', keyboardCallback);
        };
    }, [tabList, onClose]);
    return (react_1.default.createElement(Fade_1.default, { in: open, timeout: 150 },
        react_1.default.createElement("div", { className: classes.outerRoot },
            react_1.default.createElement(Slide_1.default, { direction: "left", in: open, timeout: 300, ref: modalParent }, open &&
                (react_1.default.createElement(Paper_1.default, { className: `${classes.innerRoot} ${isHalfModal ? classes.innerRootHalf : classes.innerRootFull}`, style: paperStyles, ref: modal },
                    CloseButton && react_1.default.createElement(CloseButton, { onClick: handleOnClickClose, tabIndex: 0 }),
                    react_1.default.createElement("div", { className: classes.container },
                        Title && (react_1.default.createElement("div", { className: classes.header },
                            react_1.default.createElement(Typography_1.default, { variant: "h2", component: "h1" },
                                react_1.default.createElement(Title, null)))),
                        children)))))));
};
exports.SlideModal = SlideModal;
const useStyles = makeStyles_1.default((theme) => {
    return {
        outerRoot: {
            display: 'flex',
            justifyContent: 'end',
            width: '100vw',
            height: '100vh',
            background: 'rgba(0, 0, 0, 0.7)',
            zIndex: theme.zIndex.modal,
            position: 'fixed',
            top: 0,
            left: 0
        },
        innerRoot: {
            height: '100vh',
            borderRadius: 0,
            marginLeft: 'auto'
        },
        innerRootHalf: {
            width: 500
        },
        innerRootFull: {
            width: '95%'
        },
        container: {
            height: '100%',
            marginTop: -48
        },
        header: {
            justifyContent: 'center',
            alignItems: 'center',
            display: 'flex',
            minHeight: 100,
            paddingLeft: theme.spacing(6)
        }
    };
});
exports.default = exports.SlideModal;
